import { formatCurrency } from '../../helper'

export type DellPriceListItem = {
  lobDescription: string
  chassisId: number | null
  chassisDescription: string | null
  legend: string | null
  sku: string
  skuType: string | null
  discountCategory: string | null
  productDescription: string
  retailPrice: number | null
  countryOfOrigin: string | null
  warrantyCode: string | null
  warranty: string | null
  isaFlag: string | null
  skuDescription: string | null
  sin: string | null
  cmModuleId: number | null
  costTypeId: string | null
}

export const DELL_SECTIONS = ['Identity', 'Description', 'Pricing', 'Codes', 'Warranty', 'Flag']

export type DellSection = (typeof DELL_SECTIONS)[number]

export type DellFieldRow = {
  fieldNumber: string
  name: string
  description: string
  section: DellSection
  accessor: (item: DellPriceListItem) => string
}

const dash = '—'
const text = (v: string | null | undefined) => v || dash
const num = (v: number | null | undefined) => (v === null || v === undefined ? dash : String(v))
const currency = (v: number | null | undefined) => (v === null || v === undefined ? dash : formatCurrency(v))

export const DELL_FIELD_ROWS: DellFieldRow[] = [
  //Identity
  {
    fieldNumber: '02',
    name: 'Chassis ID',
    description: 'Defines the asset tag name for the Dell chassis category',
    section: 'Identity',
    accessor: item => num(item.chassisId),
  },
  {
    fieldNumber: '04',
    name: 'Legend',
    description: 'Dell hardware point ID label',
    section: 'Identity',
    accessor: item => text(item.legend),
  },
  {
    fieldNumber: '05',
    name: 'SKU',
    description: 'Dell internal SKU number',
    section: 'Identity',
    accessor: item => text(item.sku),
  },
  {
    fieldNumber: '06',
    name: 'SKU_TYPE',
    description: 'Dell SKU type',
    section: 'Identity',
    accessor: item => text(item.skuType),
  },
  {
    fieldNumber: '15',
    name: 'SIN',
    description: 'Special Item Number',
    section: 'Identity',
    accessor: item => text(item.sin),
  },
  {
    fieldNumber: '16',
    name: 'CMModuleID',
    description: 'Dell CM Module ID number',
    section: 'Identity',
    accessor: item => num(item.cmModuleId),
  },
  {
    fieldNumber: '17',
    name: 'CostTypeID',
    description: 'Cost Type ID number',
    section: 'Identity',
    accessor: item => text(item.costTypeId),
  },
  //Description
  {
    fieldNumber: '03',
    name: 'Chassis Description',
    description: 'Chassis Description',
    section: 'Description',
    accessor: item => text(item.chassisDescription),
  },
  {
    fieldNumber: '01',
    name: 'LOB_Description',
    description: 'Line of Business Description',
    section: 'Description',
    accessor: item => text(item.lobDescription),
  },
  {
    fieldNumber: '08',
    name: 'Product Description',
    description: 'Dell Product Description',
    section: 'Description',
    accessor: item => text(item.productDescription),
  },
  {
    fieldNumber: '14',
    name: 'SKU_Description',
    description: 'SKU Description',
    section: 'Description',
    accessor: item => text(item.skuDescription),
  },
  //Pricing
  {
    fieldNumber: '09',
    name: 'Retail Price',
    description: 'Retail Price for Dell item',
    section: 'Pricing',
    accessor: item => currency(item.retailPrice),
  },
  {
    fieldNumber: '07',
    name: 'Discount Category',
    description: 'Dell discount category for item price',
    section: 'Pricing',
    accessor: item => text(item.discountCategory),
  },
  //Codes
  {
    fieldNumber: '10',
    name: 'Country Of Origin',
    description: 'Dell item country of origin',
    section: 'Codes',
    accessor: item => text(item.countryOfOrigin),
  },
  {
    fieldNumber: '11',
    name: 'Warranty Code',
    description: 'Dell item warranty code',
    section: 'Codes',
    accessor: item => text(item.warrantyCode),
  },
  //Warranty
  {
    fieldNumber: '12',
    name: 'Warranty',
    description: 'Dell item warranty',
    section: 'Warranty',
    accessor: item => text(item.warranty),
  },
  //Flag
  {
    fieldNumber: '13',
    name: 'ISAFlag',
    description: 'Dell item ISA flag',
    section: 'Flag',
    accessor: item => text(item.isaFlag),
  },
]
